/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useDebounce } from "react-use";
import { useGetTagsByKeyLazyQuery } from "~/generated/graphql";
import { Autocomplete } from "~/components";
import { DEBOUNCE_TIMEOUT_MS, FETCH_LIMIT, MINIMAL_LENGTH } from "./constants";

type Props = {
  inputValue: string;
  onChange: (value: string) => void;
  debounce?: number;
  fetchLimit?: number;
  minimalLength?: number;
  placeholder?: string;
};

export function InputName({
  inputValue,
  onChange,
  debounce = DEBOUNCE_TIMEOUT_MS,
  fetchLimit = FETCH_LIMIT,
  minimalLength = MINIMAL_LENGTH,
  placeholder,
}: Props) {
  const [value, setValue] = React.useState(inputValue);

  const [getTags, { data, loading }] = useGetTagsByKeyLazyQuery();

  useDebounce(
    () => {
      if (value.length >= minimalLength) {
        void getTags({ variables: { key: value, limit: fetchLimit } });
      }
    },
    debounce,
    [value]
  );

  const proposed = data?.searchTagKeys?.keys ?? [];

  return (
    <Autocomplete
      id="tag-name"
      items={proposed}
      loading={loading}
      value={value}
      placeholder={placeholder}
      onSelect={onChange}
      onChange={(newValue) => {
        setValue(newValue);
        onChange(newValue);
      }}
    />
  );
}
